





















import { Component, Vue } from 'vue-property-decorator'
import Axios from 'axios'
import { ARTISTTITLE_SEPARATOR_CODE, TRACKMATCHING_METHODS } from '@/store/modules/trackmatching'

@Component({
  components: {
    HelpCircle: require('@/components/HelpCircle').default,
    SpotifyAuth: require('@/components/SpotifyAuth').default
  }
})
export default class SpotifyPlaylist extends Vue {
  playlistLink: string = ''
  fuzzySearch: boolean = true
  loading: boolean = false
  modalOpen: boolean = false

  get disabled(): boolean {
    return !this.playlistLink.includes('tidal.com/browse/playlist')
  }

  open() {
    this.modalOpen = true
  }

  close() {
    this.modalOpen = false
  }

  async confirm() {
    if (this.loading) return

    this.loading = true

    try {
      const { data } = await Axios.get('/tidal/playlist-tracks', {
        params: {
          playlistLink: this.playlistLink
        }
      })

      if (!data.exists) {
        this.$buefy.dialog.alert({
          title: 'Playlist does not exist',
          message: 'This playlist does not seem to exist. Please make sure the playlist link is correct.'
        })
      } else {
        const lines = data.tracks.map(x => [x.artist, x.title])

        this.$store.commit('trackmatching/setMethod', TRACKMATCHING_METHODS.Tidal)
        this.$store.commit('trackmatching/setParsedLines', lines)
        this.$store.commit('trackmatching/setShowInputControls', false)
        this.$store.commit('trackmatching/setSeparator', ARTISTTITLE_SEPARATOR_CODE)
        this.$store.commit('trackmatching/setLines', lines.map(x => x.join(` ${ARTISTTITLE_SEPARATOR_CODE} `)))
        this.$store.commit('trackmatching/setFuzzySearch', true)
        this.$store.commit('trackmatching/setSwapArtistTitle', false)
        this.$store.commit('trackmatching/setPlaylistPrefix', 'Tidal')

        await this.$router.push({
          name: 'trackmatching parsed'
        })
      }
    } catch (error) {
      console.error(error)
    }

    this.loading = false
  }
}
